var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"component":_vm.$options.name},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" Privacy Notice ")]},proxy:true},(_vm.site)?{key:"body",fn:function(){return [_c('app-common-privacy')]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }